module.exports = __webpack_public_path__ + "images/icons/size-guide/10x30.svg";